import { render, staticRenderFns } from "./latest_articles_block.vue?vue&type=template&id=b1e31550&lang=pug"
import script from "./latest_articles_block.vue?vue&type=script&lang=js"
export * from "./latest_articles_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports